export default __webpack_public_path__ + "static/media/10.73dec0c6.svg";